"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExhibitionDetailItemsRequestSchema = exports.ExhibitionDetailItemsResponseSchema = exports.ProductItemSchema = exports.ExhibitionDetailHeaderResponseSchema = exports.ExhibitionListResponseSchema = exports.ExhibitionListItemSchema = exports.ExhibitionHeaderResponseSchema = exports.ExhibitionListInputScheme = exports.ExhibitionCalendarType = exports.ExhibitionBadgeType = exports.ExhibitionCategoryType = void 0;
var zod_1 = require("zod");
var list_1 = require("../list");
/** 기획전 카테고리 type */
exports.ExhibitionCategoryType = {
    all: 'ALL',
    entertainment: 'ENTERTAINMENT',
    hotel: 'DOMESTIC_HOTEL',
    motel: 'DOMESTIC_MOTEL',
    pension: 'DOMESTIC_PENSION',
    'guest-house': 'DOMESTIC_GUEST_HOUSE',
    leisure: 'DOMESTIC_LEISURE',
    'global-stay': 'GLOBAL_STAY',
};
/** 기획전 뱃지 type */
exports.ExhibitionBadgeType = {
    NONE: 'NONE',
    ANCORE: 'ANCORE',
    LOWPRICE: 'LOWPRICE',
    DISCOUNT: 'DISCOUNT',
    COUPON: 'COUPON',
    EVENT: 'EVENT',
    MD_RECOMMEND: 'MD_RECOMMEND',
};
exports.ExhibitionCalendarType = {
    DOMESTIC_STAY: 'DOMESTIC_STAY',
    GLOBAL_STAY: 'GLOBAL_STAY',
};
exports.ExhibitionListInputScheme = zod_1.z.object({
    page: zod_1.z.number().int().positive().optional(),
    limit: zod_1.z.number().int().positive().optional(),
    exhibitionCategory: zod_1.z.nativeEnum(exports.ExhibitionCategoryType).optional(),
});
exports.ExhibitionHeaderResponseSchema = zod_1.z.object({
    title: zod_1.z.string(),
    items: zod_1.z.array(zod_1.z.object({
        type: zod_1.z.nativeEnum(exports.ExhibitionCategoryType),
        title: zod_1.z.string(),
        serverLogMeta: zod_1.z.object({
            categoryFilter: zod_1.z.string(),
        }),
    })),
});
exports.ExhibitionListItemSchema = zod_1.z.object({
    id: zod_1.z.string(),
    title: zod_1.z.string(),
    subtitle: zod_1.z.string().nullish(),
    luckId: zod_1.z.string().nullish(),
    representative: zod_1.z.object({
        domain: zod_1.z.string(),
        path: zod_1.z.string(),
        width: zod_1.z.number(),
        height: zod_1.z.number(),
        filename: zod_1.z.string(),
    }),
    badge: zod_1.z.object({
        bgColor: zod_1.z.string(),
        title: zod_1.z.string().nullish(),
        type: zod_1.z.nativeEnum(exports.ExhibitionBadgeType),
    }),
    logMeta: zod_1.z.object({
        deepLinkUri: zod_1.z.string(),
        exhibitionTitle: zod_1.z.string(),
        object: zod_1.z.string(),
        objectType: zod_1.z.string(),
        position: zod_1.z.number(),
    }),
    uiExpMeta: zod_1.z
        .object({
        expElementType: zod_1.z.string(),
        expElementPosition: zod_1.z.number(),
        expElement: zod_1.z.string(),
    })
        .optional(),
});
exports.ExhibitionListResponseSchema = zod_1.z.object({
    data: zod_1.z.array(exports.ExhibitionListItemSchema),
    paging: zod_1.z.object({
        current: zod_1.z.number(),
        isLast: zod_1.z.boolean(),
    }),
});
/*
  기획전 상세 헤더 조회
  @see {@link https://fe-api-doc.dev.yanolja.in/#tag/Exhibition/paths/~1exhibitions~1v2~1%7Bid%7D~1header/get}
 */
exports.ExhibitionDetailHeaderResponseSchema = zod_1.z.object({
    id: zod_1.z.string(),
    title: zod_1.z.string(),
    subtitle: zod_1.z.string().nullish(),
    alwaysOn: zod_1.z.boolean().nullish(),
    images: zod_1.z
        .array(zod_1.z.object({
        anchor: zod_1.z.string().nullish(),
        info: zod_1.z.object({
            domain: zod_1.z.string(),
            path: zod_1.z.string(),
            filename: zod_1.z.string(),
            width: zod_1.z.number(),
            height: zod_1.z.number(),
        }),
        action: zod_1.z
            .object({
            deeplink_uri: zod_1.z.string(),
            url: zod_1.z.string(),
        })
            .nullish(),
        serverLogMeta: zod_1.z.record(zod_1.z.unknown()).nullish(),
    }))
        .nullish(),
    period: zod_1.z
        .object({
        startDate: zod_1.z.string(),
        endDate: zod_1.z.string(),
    })
        .nullish(),
    representative: zod_1.z
        .object({
        domain: zod_1.z.string(),
        path: zod_1.z.string(),
        width: zod_1.z.number(),
        height: zod_1.z.number(),
        filename: zod_1.z.string(),
    })
        .nullish(),
    badge: zod_1.z
        .object({
        type: zod_1.z.nativeEnum(exports.ExhibitionBadgeType),
        title: zod_1.z.string().nullish(),
        bgColor: zod_1.z.string(),
    })
        .nullish(),
    calendar: zod_1.z
        .object({
        type: zod_1.z.nativeEnum(exports.ExhibitionCalendarType).nullish(),
        available: zod_1.z.boolean(),
    })
        .nullish(),
    checkInDate: zod_1.z.string().nullish(),
    checkOutDate: zod_1.z.string().nullish(),
    room: zod_1.z
        .array(zod_1.z.object({
        adult: zod_1.z.number(),
        child: zod_1.z.array(zod_1.z.number()),
    }))
        .nullish(),
    singleRoom: zod_1.z
        .object({
        adult: zod_1.z.number(),
        child: zod_1.z.array(zod_1.z.number()),
    })
        .nullish(),
    tabInfo: zod_1.z
        .object({
        items: zod_1.z
            .array(zod_1.z.object({
            key: zod_1.z.string(),
            title: zod_1.z.string(),
            isDefault: zod_1.z.boolean().nullish(),
            more: zod_1.z
                .object({
                title: zod_1.z.string(),
                action: zod_1.z.object({
                    web: zod_1.z.string(),
                    app: zod_1.z.string(),
                }),
                serverLogMeta: zod_1.z.record(zod_1.z.unknown()).nullish(),
            })
                .nullish(),
            serverLogMeta: zod_1.z.record(zod_1.z.unknown()).nullish(),
        }))
            .nullish(),
    })
        .nullish(),
    option: zod_1.z
        .object({
        applyCheckInDate: zod_1.z.boolean().nullish(),
    })
        .nullish(),
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).nullish(),
});
exports.ProductItemSchema = list_1.ProductUnitSchema.extend({
    type: zod_1.z.literal('PRODUCT_ITEM'),
});
exports.ExhibitionDetailItemsResponseSchema = zod_1.z.object({
    items: zod_1.z.array(exports.ProductItemSchema).nullish(),
    paging: zod_1.z
        .object({
        isLast: zod_1.z.boolean(),
    })
        .nullish(),
});
exports.ExhibitionDetailItemsRequestSchema = zod_1.z.object({
    localAccommodation: zod_1.z.object({
        checkInDate: zod_1.z.string(),
        checkOutDate: zod_1.z.string(),
        capacityAdults: zod_1.z.number(),
        childrenAges: zod_1.z.array(zod_1.z.number()),
    }),
    globalAccommodation: zod_1.z.object({
        checkInDate: zod_1.z.string(),
        checkOutDate: zod_1.z.string(),
        rooms: zod_1.z.array(zod_1.z.object({
            capacityAdults: zod_1.z.number(),
            childrenAges: zod_1.z.array(zod_1.z.number()),
        })),
    }),
    page: zod_1.z.number().nullish(),
    subGroupId: zod_1.z.string().nullish(),
});
